<template>
    <ModalComponent
        name="addProducto"
        title="AÑADIR PRODUCTO"
        v-on:close="() => close(false)"
    >
        <FormComponent
            :producto="producto"
            :products="products"
            :desactivar="false"
            @terminado="addProducto"
        />
    </ModalComponent>
</template>

<script>
import ModalComponent from "@/components/backend/components/ModalComponent";
import FormComponent from "@/components/backend/eventos/sesiones/productos/FormComponent";

export default {
    props: ['products'],
    data() {
        return {
            loading: false,
            producto: {}
        }
    },
    methods: {
        close(actualizar) {
            this.producto = {},
            this.$emit('close', actualizar, 'addProducto');
        },
        addProducto() {
            this.loading = true;

            const params = {
                evento_id: this.$route.params.evento_id,
                sesion_id: this.$route.params.sesion_id,
                filters: {
                    tid : this.configuracion.hash_teatro
                },
                producto: {
                    id: this.producto.id,
                    precio: Number(this.producto.precio),
                    stock: Number(this.producto.stock)
                }
            }

            this.$store.dispatch(this.config.getVuexAlias('back.events.sesion.productos.add'), params).then(res => {
                this.$toast.success(res.data.message);
                this.close(true)
            }).catch(error => {
                this.$toast.error('Ha ocurrido un error');
            }).finally(() => {
                this.loading = false;
            });
        },
    },
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        }
    },
    components: {
        ModalComponent, FormComponent
    }
}
</script>
